import React from 'react'
import Step from '../../components/Step'
import ButtonSelect from '../../elements/ButtonSelect'
import Resi from '../Resi'
import {fieldName, routeName, enforce} from '../HelpersResi'
import HelpIcon from '../../elements/HelpIcon'


const floorConstruction = fieldName('floorConstruction')

export const rules = {
    [floorConstruction]: []
}



export default () => {
    const navigation = Resi.useNavigation();
    const fields = Resi.useFields();
    const options = Resi.useOptions();

    function onSelected(value:string){
        fields.setValue(floorConstruction)(value);
        navigation.goToNext();
    }

    return (
        <Step>
            <h2>Tell us about the main building material of the floors (not ground floor)</h2>
            <p>If different building materials have been used, please select the primary type of material.</p>
            <ButtonSelect 
                options={ options.data.product.FLOOR_CONSTRUCTION }
                selected={fields.value(floorConstruction)}
                colsLg={ 3 }
                colsSm={ 1 }
                callback={ onSelected }
            />
        </Step>
    )
};